import { axiosInstance } from '../../axios'

export const getContributorsApi = async () => {
    const response = await axiosInstance.post('/api/v1/contributors/get')
    return response.data
}
